import dayjs from 'dayjs';

const horizontalLabels = (index: number) => {
  const currentDate = dayjs();
  if (index === 0) {
    const monthNames = [];
    for (let i = 0; i < 12; i++) {
      const previousMonth = currentDate.subtract(i, 'month');
      const monthName = previousMonth.format('MMM');
      monthNames.push(monthName);
    }
    const reversedMonthNames = monthNames.reverse();
    return reversedMonthNames;
  } else if (index === 1) {
    const dayNames = [];
    for (let i = 0; i < 30; i++) {
      const previousDay = currentDate.subtract(i, 'day');
      const dayName = previousDay.format('DD MMM');
      dayNames.push(dayName);
    }
    const reverseDayNames = dayNames.reverse();
    return reverseDayNames;
  } else if (index === 2) {
    const dayNames = [];
    for (let i = 0; i < 7; i++) {
      const previousDay = currentDate.subtract(i, 'day');
      const dayName = previousDay.format('ddd');
      dayNames.push(dayName);
    }
    const reverseDayNames = dayNames.reverse();
    return reverseDayNames;
  } else if (index === 3) {
    return ['Today'];
  }
};

export default horizontalLabels;
